import ArrowDown from "@components/Icons/ArrowDown";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const HeaderToggleButton = ({ onToggle, isExpanded }) => (
  // TODO: website-next - Replace with Button component
  <button
    className={
      isBricoStore
        ? "rounded-full bg-gray-lighter px-3 py-2"
        : "rounded bg-filterYellow px-3 py-2"
    }
    onClick={onToggle}
  >
    {isExpanded ? "Ascunde" : "Detalii"}

    {/* <span
      className={`inline-block transition-[rotate] ease-linear origin-center ${
        isExpanded ? "rotate-180" : "rotate-0"
      }`}
    >
      <ArrowDown />
    </span> */}
  </button>
);

export default HeaderToggleButton;
